/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { CSVLink } from 'react-csv';
// import makeAnimated from 'react-select/lib/animated';
import Axios from "axios";
// Styles
import './BlacklistInfoList.scss';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Tooltip from '@material-ui/core/Tooltip';

// Utils
import {
  stableSort,
  getSorting,
} from '../../../../utils/functions';
import {isAdminHasPermission, inAdminPermissions} from "../../../../utils/authChecker";

// import Icon from '../../../../global/images/icons/Icon';

import {
  Button, Dialog,
  DialogActions,
  DialogContent, DialogTitle, styled,
  Typography
} from '@material-ui/core';
import {getCurCurrencyOfUnit} from "../../../../utils/util";
// import {blackoutCDKWarn, deleteCDKBlacklist, getCDKBlacklistRecords} from "../../../../epics/adminEpic";

const TableHeaderCell = withStyles(theme => ({
  head: {
    color: '#9b9b9b',
    fontWeight: '400',
    letterSpacing: '1.2px',
    fontSize: '14px',
  },
}))(TableCell);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    width:'550px'
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialog-paperWidthSm': {
    backgroundColor: '#322d38',
    borderRadius:'8px',
    display:'flex',
    alignItems:'center',
    width:'610px',
    padding:'10px',
    maxWidth:'610px',
  },
  '& .MuiDialogContent-dividers': {
    borderTop:'0px',
    borderBottom:'0px'
  },
  '& .MuiTypography-h6': {
    textTransform:'none'
  },
  '& .pay-note': {
    width:'100%',
    padding:'8px',
    background:'#2d2d2d',
    border:'1px solid #3d3d3d',
    borderRadius: '4pxv',
    color:'#ffffff',
  },
}));

class BlacklistInfoList extends React.Component {
  constructor(props) {
    super(props);

    let endDate = new Date()
    //endDate.setHours(23,59,59,999)
    let startDate = new Date()
    startDate.setDate(endDate.getDate() - 7)
    //startDate.setHours(0,0,0,0)
    //console.log(startDate,endDate);
    if(props.search?.dateBegin){
      startDate=new Date(props.search?.dateBegin);
    }
    if(props.search?.dateEnd){
      endDate=new Date(props.search?.dateEnd);
    }

    this.props = props;
    this.state = {
      orderBy: false,
      order: 'desc',
      numPage: 1,
      questTab: 2,
      filtersModal: false,
      daysFilter: 1,
      questsOptions: [],
      paypalLoaded: false,
      filters: {
        searchAll: true,
        searchSubject: false,
        searchNoizEmail: false,
        searchNoiz: false,
        paypalStatusAll: true,
        paypalStatusSuccess: false,
        paypalStatusDenied: false,
        paypalStatusPending: false,
        paypalStatusRefunded: false,
        paypalStatusPartiallyRefunded: false,
        searchValue: '',
        startDate:startDate,
        endDate:endDate,
        orderStatus:"c",
      },

      filtersClear: {
        searchAll: true,
        searchSubject: false,
        searchNoizEmail: false,
        searchNoiz: false,
        paypalStatusAll: true,
        paypalStatusSuccess: false,
        paypalStatusDenied: false,
        paypalStatusPending: false,
        paypalStatusRefunded: false,
        paypalStatusPartiallyRefunded: false,
        searchValue: '',
        startDate:startDate,
        endDate:endDate,
        approveStatus:"0,",
      },
      search:props.search?props.search.search:"",
      dateStart:startDate,
      dateEnd:endDate,
      filtersBackup: {},
      sorting: false,
      approveOrderId:"",
      approveOrderId1:"",
      approveType:0,
      withdrawOrder:{
        orderId:'',
        orderNo:'',
        userName:'',
        paymentEmail:'',
        balance:0,
      },
      dialogConfirmOpen:false,
      dialogRemoveOpen:false,
      dialogResultOpen:false,
      payResult:false,
      blacklistId:'',
      blackUserName:'',
      reason:'',
      blackoutUserId:'',
      blackoutUserName:'',
      blackoutReason:'',
    };
  }

  handleStartDateChange = (date) =>{
    //const newDateStart = event.target.value
    //console.log(newDateStart,typeof newDateStart);
    if(date){
     // const date = new Date(newDateStart);
     // date.setHours(0,0,0,0);
      //console.log(date,typeof date);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          startDate:date
        }
      }));
    }

  }

  handleEndDateChange = (event) =>{
    const newDateEnd = event.target.value
    if(newDateEnd){
      let date = new Date(newDateEnd);
      //date.setHours(23,59,59,999);
      //console.log(date,typeof date);
      this.setState(prevState =>({
        filters:{
          ...prevState.filters,
          endDate:date
        }
      }));
    }
  }

  UNSAFE_componentWillMount() {
    const { token } = this.props.auth;
    if (!this.props.admin.cdkOrders.isLoading) {
      this.props.getCDKBlacklistRecords(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    if (!this.props.admin.rollOutsAll.isLoading) {
      //this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { token } = this.props.auth;
    const { blacklistId:approveOrderId } = this.props.admin.approve.data;
    const { blacklistId:approveOrderId1 } = this.props.admin.orderLink.data;
    //const { data:approve,isLoading} = this.props.admin.orderLink;
    //const {Pagination:tipPagination } = this.props.admin.rollOutsAll;
    //console.log(approveOrderId,'---',this.state.approveOrderId);
    if (this.state.filters !== prevState.filters||this.state.search!==prevState.search||this.state.sorting!==prevState.sorting) {
      this.setState({
        numPage: 1,
      });

      this.props.getCDKBlacklistRecords(1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }else if(approveOrderId&&approveOrderId!==this.state.approveOrderId){
      this.props.getCDKBlacklistRecords(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
        //this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);

      this.setState({
        approveOrderId: approveOrderId,
      });
    }else if(approveOrderId1&&approveOrderId1!==this.state.approveOrderId1){
      this.props.getCDKBlacklistRecords(this.state.numPage,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
      //this.props.getRollOutAll(0,',', '{"tip":true,"approveStatus":0}', false, token,0);

      this.setState({
        approveOrderId1: approveOrderId1,
      });
    }
    //this.props.tip(tipPagination?tipPagination.totalUsers:0);


  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //const { token } = this.props.auth;

    if (this.props.admin.quests.isLoading === true && nextProps.admin.quests.isLoading === false) {
      const { data: quests } = nextProps.admin.quests;

      if (quests) {
        const questsOptions = [];
        for (let i = 0; i < quests.length; i++) {
          questsOptions.push({ value: quests[i].id, label: quests[i].title });
        }

        this.setState({
          //questsOptions,
        });
      }
    }

    // If paypal just refreshed, get payments again
    if (this.props.admin.cdkOrders.isLoading === true && nextProps.admin.cdkOrders.isLoading === false) {
      this.setState({
        //paypalLoaded: true,
      });
      //this.props.getAPaymentList(this.state.numPage, JSON.stringify(this.state.filters), this.state.sorting, token);
    }
  }

  paginationRight = () => {
    const { token } = this.props.auth;
    const { pagination } = this.props.admin.cdkOrders;
    if (pagination.totalPages < this.state.numPage + 1) {
      return;
    }
    if (!this.props.admin.cdkOrders.isLoading) {
      this.props.getCDKBlacklistRecords(this.state.numPage + 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage + 1,
    });
  }

  paginationLeft = () => {
    const { token } = this.props.auth;
    if (this.state.numPage === 1) {
      return;
    }
    if (!this.props.admin.cdkOrders.isLoading) {
      this.props.getCDKBlacklistRecords(this.state.numPage - 1,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), JSON.stringify(this.state.sorting), token,0);
    }
    this.setState({
      numPage: this.state.numPage - 1,
    });
  }

  handleSearchValueChange(event) {

    this.setState({
      //filters: {
        //...this.state.filters,
       // searchValue: event.target.value,
      //},
      search:event.target.value,
    });
  }

  openFiltersModal = () => {
    this.setState({
      filtersModal: true,
      filtersBackup: { ...this.state.filters },
    });
  }

  closeFiltersModal = () => {
    this.setState({
      filtersModal: false,
      filters: { ...this.state.filtersBackup },
    });
  }

  clearFiltersModal = () => {
    this.setState({
      filters: { ...this.state.filtersClear },
    });
  }

  applyFilters = () => {
    //const { token } = this.props.auth;

    this.setState({
      filtersModal: false,
    });

   // this.props.getAPaymentList(1, JSON.stringify(this.state.filters), this.state.sorting, token);
  }

  changeFilterSearch(name) {
    switch (name) {
      case 'searchAll':
        this.setState({
          filters: {
            ...this.state.filters,
            searchAll: true,
            searchSubject: false,
            searchNoiz: false,
            searchNoizEmail: false,
          },
        });
        break;
      case 'searchSubject':
        this.setState({
          filters: {
            ...this.state.filters,
            searchSubject: !this.state.filters.searchSubject,
            searchAll: false,
          },
        });
        break;
      case 'searchNoizEmail':
        this.setState({
          filters: {
            ...this.state.filters,
            searchNoizEmail: !this.state.filters.searchNoizEmail,
            searchAll: false,
          },
        });
        break;
      case 'searchNoiz':
        this.setState({
          filters: {
            ...this.state.filters,
            searchNoiz: !this.state.filters.searchNoiz,
            searchAll: false,
          },
        });
        break;
      default:
        this.setState({});
    }
  }

  // changePayoutFilter(name) {
  //   switch (name) {
  //     case 'paymentStatusAll':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusAll: !this.state.filters.paymentStatusAll,
  //           paymentStatusSent: false,
  //           paymentStatusFailed: false,
  //           paymentStatusNotSent: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusSent':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusSent: !this.state.filters.paymentStatusSent,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusFailed':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusFailed: !this.state.filters.paymentStatusFailed,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     case 'paymentStatusNotSent':
  //       this.setState({
  //         filters: {
  //           ...this.state.filters,
  //           paymentStatusNotSent: !this.state.filters.paymentStatusNotSent,
  //           paymentStatusAll: false,
  //         },
  //       });
  //       break;
  //     default:
  //       this.setState({});
  //   }
  // }

  changePayPalFilter(name) {
    switch (name) {
      case 'paypalStatusAll':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusAll: !this.state.filters.paypalStatusAll,
            paypalStatusSuccess: false,
            paypalStatusDenied: false,
            paypalStatusPending: false,
            paypalStatusRefunded: false,
            paypalStatusPartiallyRefunded: false,
          },
        });
        break;
      case 'paypalStatusSuccess':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusSuccess: !this.state.filters.paypalStatusSuccess,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusDenied':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusDenied: !this.state.filters.paypalStatusDenied,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusPending':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusPending: !this.state.filters.paypalStatusPending,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusRefunded':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusRefunded: !this.state.filters.paypalStatusRefunded,
            paypalStatusAll: false,
          },
        });
        break;
      case 'paypalStatusPartiallyRefunded':
        this.setState({
          filters: {
            ...this.state.filters,
            paypalStatusPartiallyRefunded: !this.state.filters.paypalStatusPartiallyRefunded,
            paypalStatusAll: false,
          },
        });
        break;
      default:
        this.setState({});
    }
  }

  setPaymentFromDate = (event) => {
    const { target: { value } } = event;
    if (value) {
      const paymentFromDate = new Date(value).toISOString().slice(0, 10);
      this.setState({
        filters: {
          ...this.state.filters,
          paymentFromDate,
        },
      });
    } else if (value === '') {
      this.setState({
        filters: {
          ...this.state.filters,
          paymentFromDate: null,
        },
      });
    }
  }

  setPaymentToDate = (event) => {
    const { target: { value } } = event;
    if (value) {
      const paymentToDate = new Date(value).toISOString().slice(0, 10);
      this.setState({
        filters: {
          ...this.state.filters,
          paymentToDate,
        },
      });
    } else if (value === '') {
      this.setState({
        filters: {
          ...this.state.filters,
          paymentToDate: null,
        },
      });
    }
  }

  // Determine sort direction for property; set state.order and state.orderBy
  handleRequestSort = (event, property) => {
    const desc = this.state.order === 'desc' && this.state.orderBy === property;
    this.setState({
      order: desc ? 'asc' : 'desc',
      orderBy: property,
      sorting:{
        order: desc ? 'asc' : 'desc',
        orderBy:property?property:false,
      }
    });
  }

  handleQuestFilterChange(selectedOptions) {
    this.setState({
      filters: {
        ...this.state.filters,
        quests: selectedOptions,
      },
    });
  }

  renderFiltersModal() {
    return (
      <section className="ModalMaster active">
        <section className="Modal active">
          <button onClick={this.closeFiltersModal.bind(this)} className="Modal__layer" aria-hidden />
          <section className="Modal__wrapper Filters">
            <div className="Filters__title">
              Select the filters you want to apply
            </div>

            <div className="Filters__title left">
              Report for a specific user:
            </div>

            <div className="Filters__section">
              <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px' }}>
                  Search by:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchAll', false)}
                    className={classNames('', { active: this.state.filters.searchAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchSubject', false)}
                    className={classNames('', { active: this.state.filters.searchSubject })}
                  >
                    Subject
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchNoizEmail')}
                    className={classNames('', { active: this.state.filters.searchNoizEmail })}
                  >
                    Noiz Email
                  </button>
                  <button
                    onClick={this.changeFilterSearch.bind(this, 'searchNoiz')}
                    className={classNames('', { active: this.state.filters.searchNoiz })}
                  >
                    Noiz Username
                  </button>
                </div>
              </div>
              <div className="Filters__fieldGroup" style={{ marginTop: '0px' }}>
                <input
                  type="text"
                  value={this.state.filters.searchValue}
                  onChange={this.handleSearchValueChange.bind(this)}
                  style={{ display: 'flex' }}
                />
              </div>
            </div>

            <div className="Filters__title left">
              Filter options:
            </div>


            <div className="Filters__section">
              {/* <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px' }}>
                  Payout Status:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusAll')}
                    className={classNames('', { active: this.state.filters.paymentStatusAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusSent')}
                    className={classNames('', { active: this.state.filters.paymentStatusSent })}
                  >
                    Sent
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusFailed')}
                    className={classNames('', { active: this.state.filters.paymentStatusFailed })}
                  >
                    Failed
                  </button>
                  <button
                    onClick={this.changePayoutFilter.bind(this, 'paymentStatusNotSent')}
                    className={classNames('', { active: this.state.filters.paymentStatusNotSent })}
                  >
                    Not Sent
                  </button>
                </div>
              </div> */}
              <div style={{ display: 'flex', alignItems: 'baseline' }}>
                <div className="Filters__field__label" style={{ marginRight: '10px', marginTop: '20px' }}>
                  PayPal Status:
                </div>
                <div className="Filters__fieldGroup" style={{ marginTop: '0px', marginBottom: '0px' }}>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusAll')}
                    className={classNames('', { active: this.state.filters.paypalStatusAll })}
                  >
                    All
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusSuccess')}
                    className={classNames('', { active: this.state.filters.paypalStatusSuccess })}
                  >
                    Success
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusDenied')}
                    className={classNames('', { active: this.state.filters.paypalStatusDenied })}
                  >
                    Denied
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusPending')}
                    className={classNames('', { active: this.state.filters.paypalStatusPending })}
                  >
                    Pending
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusRefunded')}
                    className={classNames('', { active: this.state.filters.paypalStatusRefunded })}
                  >
                    Refunded
                  </button>
                  <button
                    onClick={this.changePayPalFilter.bind(this, 'paypalStatusPartiallyRefunded')}
                    className={classNames('', { active: this.state.filters.paypalStatusPartiallyRefunded })}
                  >
                    Partially Refunded
                  </button>
                </div>
              </div>
            </div>

            <div className="Filters__section" style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
              <div className="Filters__field__label" style={{ marginRight: '10px', marginTop: '20px', float: 'left' }}>
                Transaction Date:
              </div>
              <div className="date__section">
                From Date
                <input
                  type="date"
                  value={this.state.filters.paymentFromDate}
                  onChange={this.setPaymentFromDate.bind(this)}
                  className="date__picker"
                />
              </div>
              <span style={{ margin: '0px 10px' }}> - </span>
              <div className="date__section">
                To Date
                <input
                  type="date"
                  value={this.state.filters.paymentToDate}
                  onChange={this.setPaymentToDate.bind(this)}
                  className="date__picker"
                />
              </div>
            </div>
            <div className="Filters__section" style={{ marginTop: '20px' }}>
              {/* }  <div className="Filters__fieldGroup">
                <div className="Filters__field__label">
                  Quests:
                </div>
                <Select
                  value={this.state.filters.quests}
                  closeMenuOnSelect={false}
                  components={makeAnimated()}
                  isMulti
                  onChange={(...args) => this.handleQuestFilterChange(...args)}
                  options={this.state.questsOptions}
                  styles={colourStyles}
                />
              </div> */}
            </div>

            <div className="Filters__close" style={{ paddingTop: '20px' }}>
              <button
                onClick={this.closeFiltersModal.bind(this)}
              >
                <i className="fa fa-times" /> Cancel
              </button>
              <button
                onClick={this.clearFiltersModal.bind(this)}
              >
                <i className="fa fa-eraser" /> Clear
              </button>
              <button
                onClick={this.applyFilters.bind(this)}
              >
                <i className="fa fa-check" /> Apply
              </button>
            </div>
          </section>
        </section>
      </section>
    );
  }

  renderFiltersString = (forFileName) => {
    const { filters } = this.state;
    const filterArray = [];

    if (filters.searchAll && filters.searchValue) {
      filterArray.push(`Subject: ${filters.searchValue}`);
      filterArray.push(`Noiz Email: ${filters.searchValue}`);
      filterArray.push(`Noiz Username: ${filters.searchValue}`);
    } else if (filters.searchsearchSubject) {
      filterArray.push(`Subject: ${filters.searchValue}`);
    } else if (filters.searchNoizEmail) {
      filterArray.push(`Noiz Email: ${filters.searchValue}`);
    } else if (filters.searchNoiz) {
      filterArray.push(`Noiz Username: ${filters.searchValue}`);
    }

    // if (filters.paymentStatusAll) {
    //   filterArray.push('Payout Status: All');
    // } else {
    //   let paymentFilters = [];
    //   if (filters.paymentStatusSent) {
    //     paymentFilters.push('Sent');
    //   }
    //   if (filters.paymentStatusFailed) {
    //     paymentFilters.push('Failed');
    //   }
    //   if (filters.paymentStatusNotSent) {
    //     paymentFilters.push('Not Sent');
    //   }
    //   if (paymentFilters.length) {
    //     filterArray.push('Payment Status: ' + paymentFilters.join(", "));
    //   }
    // }

    if (filters.paypalStatusAll) {
      //filterArray.push('Paypal Status: All');
    } else {
      const paypalFilters = [];
      if (filters.paypalStatusPending) {
        paypalFilters.push('Pending');
      }
      if (filters.paypalStatusSuccess) {
        paypalFilters.push('Success');
      }
      if (filters.paypalStatusDenied) {
        paypalFilters.push('Denied');
      }
      if (filters.paypalStatusRefunded) {
        paypalFilters.push('Refunded');
      }
      if (filters.paypalStatusPartiallyRefunded) {
        paypalFilters.push('Partially Refunded');
      }

      if (paypalFilters.length) {
        filterArray.push(`Paypal Status: ${paypalFilters.join(', ')}`);
      }
    }

    // if (filters.quests) {
    //   filterArray.push('Quests: ' + filters.quests.map((quest) => quest.label).join(", "));
    // }

    if (filters.startDate && filters.endDate) {
      filterArray.push(`Transaction Date: ${moment(filters.startDate).format('MMMM DD, YYYY')} - ${moment(filters.endDate).format('MMMM DD, YYYY')}`);
    } else if (filters.startDate) {
      filterArray.push(`Transaction Date: After ${moment(filters.startDate).format('MMMM DD, YYYY')}`);
    } else if (filters.endDate) {
      filterArray.push(`Transaction Date: Before ${moment(filters.endDate).format('MMMM DD, YYYY')}`);
    }

    if (filterArray.length === 0) {
      return 'None';
    }

    // Determine delimiter
    if (forFileName) {
      const filterStrings = filterArray.map(filter => filter.replace(/[^a-z0-9+]+/gi, '-'));
      return filterStrings.join('_');
    }
    return filterArray.join(', ');
  }

  getReason = (reasons)=>{
    if(reasons.length>0){
      return reasons.map(r=>(
          <p style={{fontSize:'0.875rem'}}>{r}</p>
      ));
    }
  }

  // Sort & define payment rows; return elements to display
  getCDKOrdersRows = (payments) => {
    if (payments.length) {
      const sortedPayments = stableSort(payments, getSorting(this.state.order, this.state.orderBy));
      return sortedPayments.map(payment => (
        <TableRow hover tabIndex={-1} key={payment.blacklistId}>
          <TableCell align="center">{payment.userName ? payment.userName : '-'}</TableCell>
          <TableCell align="center">{payment.userEmail ? payment.userEmail : '-'}</TableCell>
          <TableCell align="center">{payment.startTime ? moment(payment.startTime).format('MM/DD/YYYY hh:mm A') : '-'}</TableCell>
          <TableCell align="center" style={{color:payment.permanent?'#f30808':'#08f31a'}}>{payment.permanent?'permanent':(payment.endTime ? moment(payment.endTime).format('MM/DD/YYYY hh:mm A') : '-')}</TableCell>
          <TableCell align="center">{payment.permanent?(payment.blackoutReason ? payment.blackoutReason : '-'):(payment.reason&&payment.reason.length>0 ? this.getReason(payment.reason) : '-')}</TableCell>
          <TableCell align="center">
            <div className="table-cell" style={{ display: 'flex',justifyContent:'center' }}>
            <Tooltip title="Lift the alert" placement="top">
              <button className="table-cell-cta" onClick={this.handleRemoveOpen.bind(this,payment.blacklistId,payment.userName)}>
                <i className="fa fa-check" />
              </button>
            </Tooltip>
              {!payment.permanent&&<Tooltip title="Permanent restriction on trading" placement="top">
                <button className="table-cell-cta" style={{color:'#d23333'}} onClick={this.handleConfirmOpen.bind(this,payment.userId,payment.userName)}>
                  <i className="fa fa-times" />
                </button>
              </Tooltip>}
              {payment.order&&<Tooltip title="Download relevant materials" placement="top">
                <span className="table-cell-cta">
                <CSVLink data={this.getCSV(payment.order)?.data} headers={this.getCSV(payment.order)?.headers} filename={`CDKORDER-${payment.order?.orderNo}.csv`}>
                  <i className="fa fa-download" />
                </CSVLink>
                </span>
              </Tooltip>}
            </div>
          </TableCell>
        </TableRow>
      ));
    }
  }

  handleSearchChange(event) {
    //const { target: { value } } = event;
    this.setState({
      search: event.target.value,
    });
  }

  handleSearch = (event) =>{
  }

  // Define table headers; return array of headers
  getTableHeaders = () => {
    const tableHeaders = [
      {
        id: 'username', numeric: false, disablePadding: true, label: 'NOIZ Username',
      },
      {
        id: 'email', numeric: false, disablePadding: true, label: 'NOIZ Email',
      },
      {
        id: 'warningStartTime', numeric: false, disablePadding: true, label: 'Limit Trigger Time',
      },
      {
        id: 'warningEndTime', numeric: false, disablePadding: true, label: 'Limit Lifting Time',
      },
      {
        id: 'reason', numeric: false, disablePadding: true, label: 'Reason for Limit',
      },
      {
        id: 'operation', numeric: false, disablePadding: true, label: 'Operation',
      },

    ];
    return tableHeaders;
  }

  // Define data for csv download; return object with headers and data
  getCSV = (payment) => {
    const data = [];

    // for (let i = 0; i < payments.length; i += 1) {
    //   const payment = payments[i];

    // Standard CSV rows
    if (payment){
      const dataRow = {
        date: payment.orderTime ? moment(payment.orderTime).format('MMMM DD, YYYY') : '',
        orderNo: payment.orderNo,
        product: payment.productName,
        userName: payment.userName,
        gameName: payment.gameName,
        price: typeof payment.price === 'number' ? getCurCurrencyOfUnit(payment.currency, payment.price) : '-',
        amount: payment.amount,
        total: typeof payment.total === 'number' ? getCurCurrencyOfUnit(payment.currency, payment.total) : '-',
        purchaseType: payment.purchaseType === 'g' ? 'gift' : 'oneself',
        sendEmail: payment.sendEmail,
        payType: payment.payType === 'paypal' ? 'paypal' : 'noiz',
        ip: payment.ip,
        deliveryTime:payment.deliveryTime ? moment(payment.deliveryTime).format('MM/DD/YYYY hh:mm A') : '',
        viewTime: payment.viewTime ? moment(payment.viewTime).format('MM/DD/YYYY hh:mm A') : '',
      };

    data.push(dataRow);
  }
    // }

    // Standard CSV headers
    const headers = [
      { label: 'Date', key: 'date' },
      { label: 'OrderNo', key: 'orderNo' },
      { label: 'Product', key: 'product' },
      { label: 'UserName', key: 'userName' },
      { label: 'Game', key: 'gameName' },
      { label: 'Price', key: 'price' },
      { label: 'Amount', key: 'amount' },
      { label: 'Total', key: 'total' },
      { label: 'PurchaseType', key: 'purchaseType' },
      { label: 'SendEmail', key: 'sendEmail' },
      { label: 'Payment Method', key: 'payType' },
      { label: 'IP', key: 'ip' },
      { label: 'DeliveryTime', key: 'deliveryTime' },
      { label: 'CDKViewingTime', key: 'viewTime' },
    ];

    return { headers, data };
  }

  // Call api to pull down paypal payments.
  refreshRollOuts() {
    const { token } = this.props.auth;
    this.props.getPaypalPayments(token);
    this.setState({
      //paypalLoading: true,
    });
  }

  openDownloadModal1 = () => {
    const { token, user } = this.props.auth;
    const isAdmin = isAdminHasPermission(user,'Games','');
    //const isHelper = user.role === 'helper';
    //const isFinance = user.role === 'finance';
    //console.log('isFinance',isFinance);
    if (isAdmin) {
      this.props.getCDKOrderRecordsCsv(0,this.state.search?this.state.search:',', JSON.stringify(this.state.filters), this.state.sorting, token,0);
      this.setState({
        downloadModal: true,
      });
    }
  }

  closeDownloadModal = () => {
    this.setState({
      downloadModal: false,
    });
  }


  renderDownloadModal() {
    const { isLoading, data: payments } = this.props.admin.cdkOrdersCsv;
    const csv = this.getCSV(payments);
//console.log(isLoading);
    return (
      <section className="ModalMaster active">
        <section className="Modal active">
          <button onClick={this.closeDownloadModal.bind(this)} className="Modal__layer" aria-hidden />
          <section className="Modal__wrapper Modal__download">
            {
              (isLoading) &&
              <div className="Modal__download--spinner">
                <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
              </div>
            }
            {
              (!isLoading) &&
              <div className="Modal__download--content">
                <div className="Modal__download--header">
                  Download
                </div>
                <div className="Modal__download--body">
                  <div className="Modal__download--row">
                    <CSVLink data={csv.data} headers={csv.headers} filename={`PurchaseRecord-${this.renderFiltersString(true)}.csv`}>
                      <i className="fa fa-download" />&nbsp;{`Search Results (${payments.length})`}
                    </CSVLink>
                  </div>
                </div>
                <div className="Modal__download--footer">
                  <button
                    onClick={this.closeDownloadModal.bind(this)}
                    className="Modal__download--cta"
                  >
                    <i className="fa fa-times" />&nbsp;Close
                  </button>
                </div>
              </div>
            }
          </section>
        </section>
      </section>
    );
  }

  onDrop = (file) => {

    if (file?.target?.files[0]) {
      /* this.setState({
        uploading: req.id,
      }); */

      this.uploadFile(file?.target?.files[0]);
    }
  }

  uploadFile = (file) => {
    const { token } = this.props.auth;

    const formData = new FormData();
    formData.append("file", file);

    Axios({
      method: 'POST',
      url: '/api/v1/admin/user/update-tickets',
      headers: {
        Authorization: `JWT ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,

    }).then(res => {

      alert('success');
    })
    .catch(err => {
      console.log(err, "err");
      alert('upload failed');
    });
  };

  approveOrder = (orderId,approveType) => {
    //console.log(orderId,approveType);
    if(!orderId||!approveType){
      return;
    }
    // const { token } = this.props.auth;

    if (!this.props.admin.approve.isLoading) {
      //this.props.approveRollOut(orderId,approveType, token);
    }
  }

  handleConfirmClose = () => {
    this.setState({ dialogConfirmOpen: false,blackoutReason:''});
  };

  handleConfirmOpen = (userId,userName) => {
    this.setState({ dialogConfirmOpen: true,blackoutUserName:userName,blackoutUserId:userId});
  };

  handleRemoveClose = () => {
    this.setState({ dialogRemoveOpen: false,reason:''});
  };

  handleRemoveOpen = (blacklistId,userName) => {
    this.setState({ dialogRemoveOpen: true,blacklistUserName:userName,blacklistId:blacklistId});
  };

  handleResultClose = () => {
    this.setState({ dialogResultOpen: false});
    //this.props.getUserWallet();
  };

  handleResultOpen = () => {
    this.setState({ dialogResultOpen: true});
  };

  submitOrder=()=>{
    const { token } = this.props.auth;
    //this.props.approveRollOut(this.state.withdrawOrder.orderId,1,token);
    this.props.showRollOutPay(this.state.withdrawOrder.orderId,token);
    //this.props.deductRoll(this.state.deductOrder.userId,this.state.deductOrder.balance,this.state.filters.region,this.state.deductOrder.deductNote,1,token);
    this.setState({ approveType: 1});
    this.handleConfirmClose();
    this.handleResultOpen();
  }

  removeBlacklist=()=>{
    const {blacklistId,reason} = this.state;
    if(!blacklistId||!reason){
      return;
    }
    const { token } = this.props.auth;
    if (!this.props.admin.approve.isLoading) {
      this.props.deleteCDKBlacklist(blacklistId,reason,token);
      this.handleRemoveClose();
    }
  }

  blackoout=()=>{
    const {blackoutUserId:userId,blackoutReason:reason} = this.state;
    if(!userId||!reason){
      return;
    }
    const { token } = this.props.auth;
    if (!this.props.admin.orderLink.isLoading) {
      this.props.blackoutCDKWarn(undefined,userId,reason,token);
      this.handleConfirmClose();
    }
  }

  render() {
    const { data: payments, isLoading, pagination={totalUsers:0,totalPages:0,pageNumber:0} } = this.props.admin.cdkOrders||{};
    //const {isTipLoading, tipPagination } = this.props.admin.rollOutsAll;
    //const { isLoading: paypalLoading, errors: paypalError } = this.props.admin.rollOuts;
    const { approveType} = this.state;
    //const { role } = this.props.auth.user;
    const isTransactions = inAdminPermissions('Transactions');
    //const isHelper = role === 'helper';
    //const isFinance = inFinance(this.props.auth.user);
    //const { orderId:approveOrderId } = this.props.admin.approve.data;
    const { isLoading:errorLoading,hasError} = this.props.admin.orderLink.errors;
    const { isLoading:approveLoading,hasError:hasApproveError} = this.props.admin.approve.errors;
    //const { approvalLink} = this.props.admin.orderLink.data;
    //console.log(this.props.admin.approve);
    const { dialogConfirmOpen,dialogRemoveOpen,dialogResultOpen } = this.state;
    //console.log(this.props.admin.approve.errors);
    //console.log(dateStart,typeof  dateStart);
    //console.log(dateEnd,typeof  dateEnd);
    //let hasError=false;
    //let haRes=false;

    const createSortHandler = property => (event) => {
      this.handleRequestSort(event, property);
    };
    //this.props.tip(tipPagination?tipPagination.totalUsers:0);
    return (
      <section className="APaymentList">
        <section className="APaymentList__wrapper">
          {isTransactions && (<h2 className="APaymentList__title"><span>RECORDS:  { pagination?pagination.totalUsers:0 } (Page {((pagination?pagination.totalPages:0)>=1)?pagination.pageNumber:0} of {pagination.totalPages})</span></h2>)}
          <section className="ToggleTable">
            <section className="ToggleTable__header">
              <div className="ToggleTable__header__left">
              </div>
              <div className="ToggleTable__header__right">
                {/* <button
                  className={classNames('')}
                  onClick={this.openFiltersModal.bind(this)}
                >
                  Filters
                </button> */}
                {(pagination?pagination.totalPages:0)>1&&(<button className="regular" onClick={this.paginationLeft.bind(this)}>
                  <i className="fa fa-arrow-left" />
                </button>)}
                {(pagination?pagination.totalPages:0)>1&&(<button className="regular" onClick={this.paginationRight.bind(this)}>
                  <i className="fa fa-arrow-right" />
                </button>)}
              </div>
            </section>
            <section className="ToggleTable__table-wrapper">
              <section className="ToggleTable__table flex-table">
                {/*<div className="row">
                  <div
                    className="table-cell headline"
                  >
                    Filters: {this.renderFiltersString(false)}
                  </div>
                </div>*/}
                <Table>
                  <TableHead>
                    <TableRow>
                      {this.getTableHeaders().map(headCell => (
                        <TableHeaderCell
                          key={headCell.id}
                          align="center"
                          padding={headCell.disablePadding ? 'none' : 'default'}
                          sortDirection="asc"
                        >
                          <TableSortLabel
                            active={this.state.orderBy === headCell.id}
                            direction={this.state.order}
                            onClick={createSortHandler(headCell.id)}
                            IconComponent={ArrowDropDownIcon}
                            style={{ marginLeft: '30px' }}
                          >
                            {headCell.label}
                            {this.state.orderBy === headCell.id ? (
                              <span style={{ display: 'none' }}>
                                {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                              </span>
                          ) : null}
                          </TableSortLabel>
                        </TableHeaderCell>))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    { (!isLoading) &&
                    this.getCDKOrdersRows(payments)
                    }
                  </TableBody>
                </Table>
                <div className="NoPayments">
                  { (isLoading) &&
                    <div className="PaymentList__loading">
                      <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
                    </div>
                  }
                  { (!isLoading && !payments.length) &&
                    <span> No Records Found </span>
                  }
                </div>
              </section>
            </section>
            {(pagination?pagination.totalPages:0)>1&&(<section className="ToggleTable__footer">
              <section className="ToggleTable__footer__left">
                <button onClick={this.paginationLeft.bind(this)}>
                  <i className="fa fa-caret-left" />
                </button>
              </section>
              <section className="ToggleTable__footer__right">
                <button onClick={this.paginationRight.bind(this)}>
                  <i className="fa fa-caret-right" />
                </button>
              </section>
            </section>)}
          </section>
        </section>
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogConfirmOpen}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{color:hasError?'#ff0000':''}}>
            Should the purchase of CDK by this account <span style={{color:'#E7F328'}}>{this.state.blackoutUserName}</span> be restricted?
          </DialogTitle>
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'left'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Reason(Required)</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}></Typography>
            </div>
            <div style={{display:'flex',justifyContent:'left'}}>
              <input type="text" className="pay-note" value={this.state.blackoutReason} label="deductAmountInput" placeholder="Fill in the reason for blacklisting here" maxLength="20" onChange={event => this.setState({ blackoutReason: event.target.value})}/>
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#CAC1C4',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.handleConfirmClose.bind(this)}>
              Cancel
            </Button>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#76b452',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.blackoout.bind(this)}>
              Confirm
            </Button>
          </DialogActions>
      </BootstrapDialog>

        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogRemoveOpen}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{color:hasError?'#ff0000':''}}>
            Is it confirmed to lift the CDK purchase restriction for this user <span style={{color:'#E7F328'}}>{this.state.blacklistUserName}</span>?
          </DialogTitle>
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'left'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',}}>Reason(Required)</Typography>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'200px',textAlign:'right'}}></Typography>
            </div>
            <div style={{display:'flex',justifyContent:'left'}}>
              <input type="text" className="pay-note" value={this.state.reason} label="deductAmountInput" placeholder="Fill in the reason for removing restrictions here" maxLength="20" onChange={event => this.setState({ reason: event.target.value})}/>
            </div>
          </DialogContent>
          <DialogActions>
            <Button autoFocus style={{fontSize:'16px',fontWeight:'800',backgroundColor:'#CAC1C4',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.handleRemoveClose.bind(this)}>
              Cancel
            </Button>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#76b452',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.removeBlacklist.bind(this)}>
              Confirm
            </Button>
          </DialogActions>
        </BootstrapDialog>

        {(!errorLoading||!approveLoading)&&((hasApproveError&&approveType===2)||approveType===1)&&<BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={!!dialogResultOpen}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" style={{color:(hasError||hasApproveError)?'#ff0000':''}}>
            {approveType===1&&((hasError)? 'Failure to payment' : 'Do you want to redirect to the payment page to complete the payment?')}
            {approveType===2&&((hasApproveError)? 'Failure to refuse' : '')}
          </DialogTitle>
          <DialogContent dividers>
            <div style={{display:'flex',justifyContent:'center'}}>
              <Typography variant='body1' component="div"  gutterBottom style={{minWidth:'150px',color:hasError?'#ff0000':''}}>
                {approveType===1&&((hasError)?'': 'Withdrawal progress can be viewed in the transaction history')}
              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#CAC1C4',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.handleResultClose.bind(this)}>
              Close
            </Button>
            {(!hasError)&&(<Button style={{marginLeft:'20px',fontSize:'16px',fontWeight:'800',backgroundColor:'#76b452',color:'#fff',borderRadius:'8px',padding:'10px 50px',boxShadow:'0px 4px 8px rgba(0,0,0,0.5)',textTransform:'none'}} onClick={this.payOrder.bind(this)}>
              Confirm
            </Button>)}
          </DialogActions>
        </BootstrapDialog>}
        {/*{ (this.state.filtersModal) && this.renderFiltersModal() }*/}
        { (this.state.downloadModal) && this.renderDownloadModal() }
      </section>
    );
  }
}

BlacklistInfoList.propTypes = {

};

export default BlacklistInfoList;
